import { render, staticRenderFns } from "./ProjectsSidebarMenu.vue?vue&type=template&id=68f9fbcf&scoped=true&"
import script from "./ProjectsSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./ProjectsSidebarMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsSidebarMenu.vue?vue&type=style&index=0&id=68f9fbcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f9fbcf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68f9fbcf')) {
      api.createRecord('68f9fbcf', component.options)
    } else {
      api.reload('68f9fbcf', component.options)
    }
    module.hot.accept("./ProjectsSidebarMenu.vue?vue&type=template&id=68f9fbcf&scoped=true&", function () {
      api.rerender('68f9fbcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/SidebarComponents/ProjectsSidebarMenu.vue"
export default component.exports